import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import NotificationsComponent from '../components/NotificationsComponent'

const mapStateToProps = (state) => {
  return {
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationsComponent)
